import styled from 'styled-components';
import { Button } from 'components/elements/button/Button';

export const TroubleshootingCodeContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.base};
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space(2)}px ${({ theme }) => theme.space(4)}px;
  margin-bottom: ${({ theme }) => theme.space(2)}px;
  margin-top: ${({ theme }) => theme.space(6)}px;

  .code {
    font-size: ${({ theme }) => theme.fontSize[2]}px;
    overflow-wrap: break-word;
    min-width: 0;
    flex: 1;
    font-family: monospace;
  }

  .text {
    display: inline-block;
    font-size: ${({ theme }) => theme.fontSize[1]}px;
    color: ${({ theme }) => theme.palette.primary.primary600};
    white-space: nowrap;
  }

  .active {
    text-decoration: underline;
  }

  img {
    vertical-align: middle;
  }

  .copy-confirmed {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    white-space: nowrap;
    line-height: 1;
    fill: currentColor;
    color: ${({ theme }) => theme.palette.primary.primary600};
  }

  svg {
    margin-inline-end: ${({ theme }) => theme.space(1)}px;
  }
`;

export const CopyCodeButton = styled(Button)`
  background-color: transparent;
  border-radius: 0;
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  width: unset;
  padding: 0;
  padding-inline-start: ${({ theme }) => theme.space(4)}px;
  margin: 0;
  line-height: 1;
  fill: currentColor;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize[2]}px;
  flex-shrink: 0;
  white-space: nowrap;
`;
